import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Pagamento } from "./models/pagamento";

@Injectable({
    providedIn: 'root'
  })

export class PagamentoService{
    
    private environmentUrl: string = '';    

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }
    


    getPagamentos() : Observable<Pagamento[]>{  
        console.log('pagamento '); 
        let url = this.environmentUrl+"/pagamento";        
        return this.httpClient.get<Pagamento[]>(url);
    }
}